import authConstant from "../constants/authConstant";

const initialState = {
    user: null,
    token: null,
    refreshToken: null,
    roleId: null,
    userId: null,
    permissions: {},
    vendor: {},
    admin: {}
}

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case authConstant.USER_AUTHENTICATE:
            return {
                ...state,
                ...action.payload,
            };
        case authConstant.USER_REGISTER:
            return {
                ...state,
                ...action.payload,
            };
        case authConstant.ADMIN_LOGIN:
            return {
                ...state,
                ...({
                    admin: {
                        ...action.payload,
                    }
                })
            };
        case authConstant.USER_LOGOUT:
            return initialState;

        case authConstant.UPDATE_VENDOR_DETAILS:
            return {
                ...state,
                vendor: {
                    ...action.payload,
                    tokenExpiryTimestamp: state.vendor.tokenExpiryTimestamp
                }
            }

        default:
            return state;
    }
};